import { useState, useEffect } from "react";
import { getUserData } from "../../utils/api/getUserData.js";
import { updateBonifications } from "../../utils/api/updateBonifications.js";

export function ProfilePage3(user) {

  
  const [residence, setResidence] = useState("no")
  const [advantage, setAdvantage] = useState("no")
  const [family, setFamily] = useState("no")

  useEffect(() => {
    // cargar datos de usuario
    loadUserData();
  }, []);

  const loadUserData = async () => {
    const loadedUserData = await getUserData(user);

    console.log(loadedUserData.data)
    
    setResidence(loadedUserData.data.residence)
    setAdvantage(loadedUserData.data.advantage)
    setFamily(loadedUserData.data.family)

  }

  const handleEditAdvantages = async () => {
    const response = await updateBonifications(user, advantage, family, residence);
    if(response){

    }
  }
  return (
    <>

      <div className="m-layMiCuenta__body">
        <div className="bx">
          <header>
            <br/>
            <span className="ht-body-bold uppercase" >Mis bonificaciones</span><br/>
            <span className="ht-body-regular">Edita o añade bonificaciones</span>
          </header>
          <div className="m-frmGroup m-frmGroup--min">
            <label for="residence">Residente</label>
            <select name="birth_date_month" id="birth_date_month" value={residence} onChange={(event)=>{setResidence(event.value)}}>)}>
              <option value="no">No</option>
              <option value="ceuta">Ceuta/Melilla</option>
              <option value="baleares">Islas Baleares</option>
              <option value="canarias">Islas Canarias</option>      
            </select>
          </div>
          <div className="m-frmGroup m-frmGroup--min">
            <label for="residence">Carnet o bonificacion especial</label>
            <select name="birth_date_month" id="birth_date_month" value={advantage} onChange={(event)=>{setAdvantage(event.value)}}>)}>
              <option value="no">No</option>
              <option value="ET1">Ejercito de tierra</option>
              <option value="FN1">Fuerza Naval</option>
              <option value="GCS">Guardia civil</option>
              <option value="POL">Policia Nacional</option>
              <option value="joven">Carnet joven</option>
              <option value="tercera">Tercera edad</option>      
            </select>
          </div>
          <div className="m-frmGroup m-frmGroup--min">
            <label for="residence">Familia numerosa</label>
            <select name="birth_date_month" id="birth_date_month" value={family} onChange={(event)=>{setFamily(event.value)}}>)}>
              <option value="no">No</option>
              <option value="FNGENERAL">General</option>
              <option value="FNESPECIAL">Especial</option>
            </select>
          </div>
          <button onClick={() => handleEditAdvantages()} class="btnOrange-l">Guardar</button>
        </div>
      </div>
    </>
  )
}